import React, { FC } from 'react';

export const SvgArrowIcon: FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={9} height={8} fill="none" viewBox="0 0 9 8">
        <path
            fill="#0070E5"
            d="M.646 3.646a.5.5 0 0 0 0 .708l3.182 3.182a.5.5 0 1 0 .708-.708L1.707 4l2.829-2.828a.5.5 0 1 0-.708-.708L.646 3.646ZM9 3.5H1v1h8v-1Z"
        />
    </svg>
);
